import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import classifications from './modules/classifications';
import cart from './modules/cart';
import advancedSearch from './modules/advancedSearch';
import loading from './modules/loading';
import orderDetail from './modules/orderDetail';
import student from './modules/student';
import home from './modules/home';

Vue.use(Vuex);

// 防止外部code影響內部
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    user,
    classifications,
    cart,
    advancedSearch,
    loading,
    orderDetail,
    student,
    home,
  },
  strict: debug,
});